import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils.ts';

export interface SpinnerProps {
  /** Size of the spinner (defaults to medium) */
  size?: 'small' | 'medium' | 'large';
  /** Color of the spinner (defaults to primary) */
  variant?: 'primary' | 'secondary' | 'white';
  /** Optional additional classNames */
  className?: string;
  /** Optional text to display below the spinner */
  text?: string;
}

/**
 * A reusable spinner component with size and color variants.
 * Uses the Loader2 icon from lucide-react with the animate-spin class.
 */
export function Spinner({
  size = 'medium',
  variant = 'primary',
  className,
  text
}: SpinnerProps) {
  // Map size string to className
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-12 w-12'
  };

  // Map variant to color
  const variantClasses = {
    primary: 'text-[#11B981]', // App's primary green
    secondary: 'text-[#F0AD00]', // App's warning/secondary color
    white: 'text-white'
  };

  return (
    <div className={cn('flex flex-col items-center justify-center', className)}>
      <Loader2
        className={cn(
          'animate-spin',
          sizeClasses[size],
          variantClasses[variant]
        )}
      />
      {text && (
        <p className="mt-2 text-sm text-gray-400">{text}</p>
      )}
    </div>
  );
}
